/**
 * Hybrid sub-brand routing for QorTrace Labs.
 *
 * When a user lands on `labs.qortrace.com/<anything>` the SPA shell is the
 * same React app, but we want them to see the Labs experience by default.
 * This component intercepts the very first render: if the host starts with
 * `labs.` and the current pathname is `/` (or empty), we hard-rewrite to
 * `/labs` so the Labs route renders.
 *
 * Anything below `labs.qortrace.com/<X>` (e.g. `/threat-radar`, `/audit`)
 * still works — visitors who deep-link straight to a path on the labs
 * subdomain get exactly that path. We only redirect the bare host.
 */
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";


export default function LabsHostRedirect() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (typeof window === "undefined") return;
    const host = window.location.hostname || "";
    const isLabsHost = host.startsWith("labs.") || host === "labs";
    if (!isLabsHost) return;
    // Only rewrite the bare-host visit.
    if (location.pathname === "/" || location.pathname === "") {
      navigate("/labs", { replace: true });
    }
  }, [location.pathname, navigate]);

  return null;
}
